import { Directive } from '@angular/core';

@Directive({
  selector: '[appComboBox]',
})
export class ComboBoxDirective {}
